import { Grid } from '@mui/material'
import { Button, TextFieldC } from 'components'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Yup } from 'utils'

import { SelectConcept } from './SelectConcept'

const schema = Yup.object({
  concept: Yup.object({
    id: Yup.string()
  }),
  details: Yup.string().max(1600)
})

type ReasonFormValues = {
  concept: { id: string; name?: string }
  details?: string
}

type Props = {
  submitLabel: string
  isLoading?: boolean
  onSubmit: (values: { conceptId: string; details?: string }) => void
  onCancel: () => void
}

export const ReasonForm = ({
  submitLabel,
  isLoading,
  onSubmit,
  onCancel
}: Props) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { concept: null }
  })

  const { handleSubmit } = methods

  const handleValid = (data: any) => {
    const values = data as ReasonFormValues
    onSubmit({ conceptId: values.concept.id, details: values.details })
  }

  return (
    <FormProvider {...methods}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SelectConcept />
        </Grid>
        <Grid item xs={12}>
          <TextFieldC name="details" label="Detalhes" multiline rows={4} />
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              gap: '1rem'
            }}
          >
            <Button
              sx={{ width: { sm: 100, md: 200 } }}
              variant="text"
              onClick={onCancel}
            >
              Fechar
            </Button>
            <Button
              sx={{ width: { sm: 100, md: 200 } }}
              type="button"
              onClick={handleSubmit(handleValid)}
              disabled={isLoading}
            >
              {submitLabel}
            </Button>
          </div>
        </Grid>
      </Grid>
    </FormProvider>
  )
}
